const projectFilters = (): void => {
  let dataFilters: any = {};
  const url = document.querySelector('html').getAttribute('data-base-url');

  const setActiveFilters = (): void => {
    const queryString = window.location.search;
    dataFilters = Object.fromEntries(new URLSearchParams(queryString));

    for (const [key, value] of Object.entries(dataFilters)) {
      const filterElements = document.querySelectorAll(
        '[data-filter][data-filter-key="' + key + '"]'
      );
      filterElements.forEach((element: any) => {
        const elementType = element.getAttribute('data-filter-type');
        if (elementType == 'button') {
          const filterValue = element.getAttribute('data-filter-value');
          if (filterValue == value) {
            element.setAttribute('selected', 'selected');
          } else {
            element.removeAttribute('selected');
          }
        }
        if (elementType == 'select') {
          const filterOptions = element.querySelectorAll('option');
          const matchingFilterOption = element.querySelector(
            '[value="' + value + '"]'
          );
          if (matchingFilterOption) {
            filterOptions.forEach((option: any) => {
              option.removeAttribute('selected');
            });
            matchingFilterOption.setAttribute('selected', 'selected');
            element.value = value;
          }
        }
      });
    }
  };

  setActiveFilters();

  const loadPage = (): void => {
    let dataFiltersString = url + '?';
    for (const [key, value] of Object.entries(dataFilters)) {
      dataFiltersString = dataFiltersString + key + '=' + value + '&';
    }
    dataFiltersString = dataFiltersString.substring(
      0,
      dataFiltersString.length - 1
    );
    window.location.href = dataFiltersString;
  };

  const applyFilters = (filterKey: any, filterValue: any): void => {
    dataFilters[filterKey] = filterValue;
    loadPage();
  };

  const clearFilter = (filterKey: any): void => {
    delete dataFilters[filterKey];
    loadPage();
  };

  const filters: any = document.querySelectorAll('[data-filter]');

  filters.forEach((filter: any) => {
    const filterType = filter.getAttribute('data-filter-type');
    if (filterType == 'button') {
      filter.addEventListener('click', () => {
        const filterKey = filter.getAttribute('data-filter-key');
        const filterValue = filter.getAttribute('data-filter-value');
        const filterStatus = filter.getAttribute('selected');
        if (filterStatus == 'selected' || filterValue == 'clear-filter') {
          clearFilter(filterKey);
        } else {
          applyFilters(filterKey, filterValue);
        }
      });
    }
    if (filterType == 'select') {
      filter.addEventListener('change', () => {
        const filterKey = filter.getAttribute('data-filter-key');
        const filterValue = filter.options[filter.selectedIndex].value;
        if (filterValue == 'clear-filter') {
          clearFilter(filterKey);
        } else {
          applyFilters(filterKey, filterValue);
        }
      });
    }
  });
};

export default projectFilters;
